import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getEmployeeeAuditLogsRequest } from 'api/requests/audit-log-requests';
import { AuditModel } from 'modules/employees/audit-logs/types';
import {
  AUDIT_LOGS__GENERAL_LOADING,
  AUDIT_LOGS__GET_EMPLOYEE_HISTORY,
  AUDIT_LOGS__GET_EMPLOYEE_HISTORY_DETAILS,
} from 'store/constants';

export const setAuditLogsRequestsLoadingAction = createAction<boolean>(AUDIT_LOGS__GENERAL_LOADING);
export const getEmployeeAuditLogsAction = createAction<AuditModel[]>(AUDIT_LOGS__GET_EMPLOYEE_HISTORY);

export const getEmployeeAuditLogDetailsAction = createAsyncThunk(
  AUDIT_LOGS__GET_EMPLOYEE_HISTORY_DETAILS,
  async (props: { employeeId: number; companyId: number }, thunkApi) => {
    thunkApi.dispatch(setAuditLogsRequestsLoadingAction(true));
    try {
      const response = await getEmployeeeAuditLogsRequest(props.employeeId, props.companyId);
      thunkApi.dispatch(getEmployeeAuditLogsAction(response));
    } catch (error) {
      console.log(error);
    }
    thunkApi.dispatch(setAuditLogsRequestsLoadingAction(false));
  },
);
